module.exports = __webpack_public_path__ + "img/ggcdw-part-fa-pic1.88a43c48.png";